import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/autorizaciones/roles";
import roles from '../../models/autorizacion/roles'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    roles: [],
    new: [],
    deleteItem: [],
    edit: [],
    rolesId: {},
    operators: [],
    opersnrol: [],
    editOpersnrol:[],
    rolDefault:null
  },

  mutations: {
    setRoles(state, data) {
      state.roles = data;
    },
    setNew(state, data) {
      state.new = data
    },
    setDeleteItem(state, data) {
      state.deleteItem = data
    },
    setEdit(state, data) {
      state.edit = data
    },
    setRolesId(state, data) {
      state.rolesId = data
    },
    setOperators(state, data) {
      state.operators = data
    },
    setOperSnRol(state, data) {
      state.opersnrol = data
    },
    seteditOpersnrol(state, data) {
      state.editOpersnrol = data
    },
    setRolDefault(state,data){
      state.rolDefault= data
    }

  },
  actions: {
    async getRoles(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getRoles();
          state.commit("setRoles",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getRolesId(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getRolesId(state.state.rolesId);
          state.commit("setRolesId",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },


      async edit(state) {
        return new Promise(async (resolve, reject) => {
          try {
            await state.state.service.edit(state.state.edit).then(() => {
              let item = state.state.edit
              let options = state.state.roles
              let indice
              options = options.map((option,index) => {
                if (option.id != state.state.edit.rolId) {
                  indice = index + 1
                  return option;
                }
            
                item = roles.fromJson({
                  rolId: item.rolId,
                  nombre: item.nombre == undefined  || null ? options[indice].name : item.nombre,
                  descripcion:item.descripcion == undefined || null ? options[indice].description  : item.descripcion
                });
                return item;
              });

              state.commit('setRoles', options)
              resolve(true)
            })
          }
          catch (error) {
            reject(error)
          }
        })

      },
      async new(state) {
        return new Promise(async (resolve, reject) => {
          try {
            await state.state.service.new(state.state.new).then((data) => {
              let item = state.state.new
              let options = state.state.roles
              let newItem = roles.fromJson({
                rolId:data.data.rolId,
                nombre:item.nombre,
                descripcion:item.descripcion
              })
              options.push(newItem);
              state.commit('setRoles', options)
              resolve(true)
            })
          }
          catch (error) {
            reject(error)
          }
        })

    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
       await state.state.service.delete(state.state.deleteItem).then(() => {

        let options = state.state.roles;
         options = options.filter((option) => {
          return option.id !== state.state.deleteItem;
        });
         
            state.commit('setRoles', options)
            resolve(true)
          });
        } catch (error) {
          reject(error)
  
        }
      })
     
    },

    async getOperators(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getOperators();
          state.commit("setOperators",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getOpersnrol(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getOpersnrol();
          state.commit("setOperSnRol",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
